import { render, staticRenderFns } from "./PaymentDebitsList.vue?vue&type=template&id=620bb494"
import script from "./PaymentDebitsList.vue?vue&type=script&lang=js"
export * from "./PaymentDebitsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports